import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

interface CaptchaWidgetProps {
  onVerified: (token: string) => void;
}

export const CaptchaWidget = ({ onVerified }: CaptchaWidgetProps): JSX.Element => {
  const captchaRef = useRef<HTMLDivElement | null>(null);
  const renderedRef = useRef(false);

  useEffect(() => {
    const renderCaptcha = () => {
      if (!SITE_KEY || renderedRef.current || !window.grecaptcha || !captchaRef.current) {
        return;
      }

      window.grecaptcha.ready(() => {
        if (renderedRef.current || !window.grecaptcha || !captchaRef.current) return;

        renderedRef.current = true;

        window.grecaptcha.render(captchaRef.current, {
          sitekey: SITE_KEY,
          callback: onVerified,
        });
      });
    };

    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = renderCaptcha;
      document.body.appendChild(script);
    } else {
      renderCaptcha();
    }
  }, [onVerified]);

  return <Box ref={captchaRef} sx={{ mt: 3, minHeight: 78 }} />;
};
